import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {
  FilteringState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableFilterRow,
  VirtualTable,
} from '@devexpress/dx-react-grid-material-ui';
import {lightBlue} from '@material-ui/core/colors';

const processOutcomeTableColumns = [
  {
    name: 'outcome',
    title: 'Outcome',
  },
  {
    name: 'outcomeSbsTitle',
    title: 'SBS',
  },
];

class ProcessOutcomeList extends PureComponent {
  TableRow = (props) => {
    const {
      props: {selectedProcessOutcome, onProcessOutcomesTableChangeSelectedRow},
    } = this;
    let colour = 'inherit';

    if (selectedProcessOutcome.id === props.row.id) {
      colour = lightBlue.A100;
    }

    return (
      <VirtualTable.Row
        {...props}
        onClick={() => onProcessOutcomesTableChangeSelectedRow(props.row)}
        style={{
          cursor: 'pointer',
          backgroundColor: colour,
        }}
      />
    );
  };

  render() {
    const {
      props: {transformedProcessOutcomes},
      TableRow,
    } = this;

    return (
      <Grid
        rows={transformedProcessOutcomes}
        columns={processOutcomeTableColumns}
      >
        <FilteringState defaultFilters={[]} />
        <IntegratedFiltering />

        <SortingState />
        <IntegratedSorting />

        <VirtualTable
          rowComponent={TableRow}
          height={
            transformedProcessOutcomes.length === 0
              ? 250
              : 53 * (transformedProcessOutcomes.length + 3) + 10
          }
        />

        <TableHeaderRow showSortingControls />
        <TableFilterRow />
      </Grid>
    );
  }
}

ProcessOutcomeList.propTypes = {
  location: PropTypes.object.isRequired,
  transformedProcessOutcomes: PropTypes.array.isRequired,
  selectedProcessOutcome: PropTypes.object.isRequired,
  onProcessOutcomesTableChangeSelectedRow: PropTypes.func.isRequired,
  onProcessOutcomesTableChangeSortOrder: PropTypes.func.isRequired,
};

export default ProcessOutcomeList;
